var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "menu.4f9fbd3d.png","uri@2x": __webpack_public_path__ + "menu.eb1f1632.png","uri@3x": __webpack_public_path__ + "menu.fcddba4f.png",
    width: 22,
    height: 18
});